import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as actions from '../../actions/actions.jsx';
import '../../stylesheet/tabdesign.css';
import LeftLink from '../leftlink/leftlink.jsx';
import AuthNavbar from '../navigation/authnavigation.jsx';
import CardPreferance from './cardpreferance.jsx';
import ChangePassword from './changepassword.jsx';
import ManagePin from './managepin.jsx';
import Messages from './messages.jsx';
import PersonalInfo from './personalinfo.jsx';
const mapStateToProps = state =>
    ({
        optionState: state.selectedTabReducer.selectedTabReducer,
        cardState: state.getCardReducer.cardState,
    })
const mapDispatchToProps = dispatch =>
    ({
        fetchSelectedTab(selectedOption) {
            dispatch(
                actions.selectedtabAction(selectedOption)
            )
        },
        fetchCard(state) {
            dispatch(
                actions.getCardAction(state)
            )
        },
    })

class MyProfile extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedOption: localStorage.getItem('taboption') || "tab1"
        }
    }
    handleChange(e) {
        this.setState({
            selectedOption: e.target.value
        })
    }
    componentWillMount() {
        this.props.fetchSelectedTab(this.state.selectedOption)
    }
    componentDidMount() {
        localStorage.setItem("comp", "profilecomp")
        this.setState({
            selectedOption: localStorage.getItem('taboption')
        })
     


     }
  
    callBack() {
        this.setState({
            selectedOption: localStorage.getItem('taboption')
        })
    }

    render() {      
       
        
        var cardTypes = localStorage.getItem('cardTypes')
        
        // const { filteredCards } = this.state
        // 
      
        return (
            <div  className="row">
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnVisibilityChange
                draggable
                pauseOnHover
            />            

                    <div className="col-md-12 m-0 p-0">
                        <AuthNavbar />
                    </div>


                <div className="container" style={{ }}>
                    <div className="row pb-5">
                    <PersonalInfo />
                    
                        
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MyProfile);


// WEBPACK FOOTER //
// ./src/components/myprofile/myprofile.jsx